// extracted by mini-css-extract-plugin
module.exports = {"CoursesPageOverflow":"CoursesPage_CoursesPageOverflow__2eM_n","CoursesPage":"CoursesPage_CoursesPage__2_-Jp","ltr":"CoursesPage_ltr__3_niV"};